import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'SearchFilteredTags',
    props: {
        guids: {
            type: Array,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const selectedTags = computed(
            () => store.getters['search/selectedTags'](props.guids[0]) ?? []
        )
        const queryString = computed(
            () => store.state.search.queries[props.guids[0]]
        )

        const clearFilterOnTag = function (tag) {
            props.guids.forEach((guid) => {
                store.dispatch('search/performSearch', {
                    guid,
                    query: queryString.value,
                    facet: tag
                })
            })
        }

        return {
            selectedTags,
            clearFilterOnTag
        }
    }
}
